var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-header"},[_c('div',{staticClass:"app-header-center"},[_c('palta-icon',{attrs:{"name":"envone","size":"big"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }